<template>
    <v-card ariant="flat" class="px-4 pt-6" style="border-radius: 14px;">
        <v-form>
            <v-card-item>
                <v-card-title>
                    <b>Add Client</b>
                    <button type="button" class="float-right"><span class="mdi mdi-close"
                            @click="$emit('close')"></span></button>
                    <!-- <v-btn color="surface-variant" text="Open Dialog" variant="flat"></v-btn> -->
                </v-card-title>
            </v-card-item>
            <v-card-text>
                <v-row class="pa-2">
                    <v-col class="py-0 px-1" cols="12">
                        <v-label class="clientLabel">About Client</v-label>
                        <v-textarea placeholder="Description" variant="outlined" :rows="3"
                            v-model="formData.aboutClient" :rules="getRules('About Client')"></v-textarea>
                    </v-col>
                    <v-col class="py-0 px-1" cols="12">
                        <v-label class="clientLabel">Their Client</v-label>
                        <!-- <TextFieldComponent density="compact" placeholder="Client Name"/> -->
                        <v-textarea placeholder="Description" variant="outlined" :rows="3"
                            v-model="formData.theirClient" :rules="getRules('Client')"></v-textarea>
                    </v-col>
                    <v-col class="py-0 px-1" cols="12">
                        <v-label class="clientLabel">e-commerce Prescence</v-label>
                        <!-- <TextFieldComponent density="compact" placeholder="Client Name"/> -->
                        <v-textarea placeholder="Description" variant="outlined" :rows="3"
                            v-model="formData.EcommercePresence" :rules="getRules('E-Commerce Presence')"></v-textarea>
                    </v-col>
                </v-row>
                <v-col cols="12" align="end">
                    <v-btn class="cancel mr-3" color="gray" @click="$emit('close')">Cancel</v-btn>
                    <v-btn class="save" type="submit" color="light-blue" @click="save">Save</v-btn>
                </v-col>
            </v-card-text>
        </v-form>
    </v-card>
</template>
<script>
export default {
    data() {
        return {
            formData: {}
        }
    },
    methods: {
        getRules(name) {
            if (name && name.toLowerCase() == "email") {
                return [
                    (value) => !!value || "E-mail is required.",
                    (value) => {
                        if (/.+@.+\..+/.test(value)) {
                            return true;
                        }
                        return "E-mail must be valid.";
                    },
                ];
            }
            return [
                (value) =>
                    (value !== null && value !== undefined && value !== "") ||
                    `${name} is required.`,
            ];
        },
        save() {
            if (this.$refs.form.validate()) {
                this.$emit("save", this.formData);
                this.formData = {};
                this.$emit("close");
            } else {
                console.log("Form not valid");
            }
        }
    }

}
</script>
<style>
/* .clientLabel {
    font-weight: 500;
    font-size: 18px;
} */
</style>